<ng-container *transloco="let t; prefix: scope">
  <span class="block text-[.5rem]" [style.lineHeight]="'.75rem'" [matTooltip]="message() ?? t('tooltip')">
    {{ t('body') }}
  </span>
</ng-container>
